﻿'use strict';

var centralApp = angular.module('app.components');

centralApp.directive('baixarArquivo', function () {

    return {
        restrict: 'A',
        scope: {
            // objeto contendo chamadoId e anexoId
            arquivo: '=baixarArquivo'
        },
        controllerAs: '$ctrl',
        controller: baixarAnexoCtrl,
        link: function ($scope, $element, $attr) {

            $element.bind('click', function (e) {
                e.preventDefault();

                $scope.baixar();
            });

        }
    }

});

baixarAnexoCtrl.$inject = ['$scope', 'notificacao', 'anexoApi'];

function baixarAnexoCtrl($scope, notificacao, anexoApi)
{
    $scope.baixar = function () {
        $scope.arquivo.baixando = true;
        anexoApi.baixarArquivo( $scope.arquivo , function (resposta) {
            saveAs(new File([resposta.data], $scope.arquivo.arquivoNome, {
                type: resposta.headers['content-type']
            }));
            $scope.arquivo.baixando = false;
        }, function(error) {
            notificacao.erro('Houve um erro ao baixar o arquivo');
            $scope.arquivo.baixando = false;
        });

    }
}


//////////////////
// WEBPACK FOOTER
// ../Projecao.ContactCenter.WebApp.Compartilhado/components/baixar-arquivo/index.js
// module id = 307
// module chunks = 1